module.exports = __webpack_public_path__ + "images/marketing/implement/6.png";